module.exports = __webpack_public_path__ + "img/4f.49246de9.png";